var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFearIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 68.0045C53.0015 68.0045 68 53.005 68 34.5022C68 15.9995 53.0015 1 34.5 1C15.9985 1 1 15.9995 1 34.5022C1 53.005 15.9985 68.0045 34.5 68.0045Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.875 16.925C18.875 16.925 19.0664 11.5527 24.3188 9.74594C24.3188 9.74594 28.7216 8.26226 31.8802 12.4979C31.8802 12.4979 24.582 9.14768 18.875 16.925Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0486 17.3317C49.0486 17.3317 49.1563 11.9474 44.0116 9.86547C44.0116 9.86547 39.6925 8.1425 36.3066 12.1987C36.3066 12.1987 43.7843 9.24329 49.0486 17.3317Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6338 38.367C49.2327 38.367 52.9609 33.2297 52.9609 26.8925C52.9609 20.5553 49.2327 15.418 44.6338 15.418C40.0348 15.418 36.3066 20.5553 36.3066 26.8925C36.3066 33.2297 40.0348 38.367 44.6338 38.367Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2456 35.6388C45.5451 35.6388 47.4092 33.0675 47.4092 29.8956C47.4092 26.7237 45.5451 24.1523 43.2456 24.1523C40.9461 24.1523 39.082 26.7237 39.082 29.8956C39.082 33.0675 40.9461 35.6388 43.2456 35.6388Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6963 38.367C28.2952 38.367 32.0234 33.2297 32.0234 26.8925C32.0234 20.5553 28.2952 15.418 23.6963 15.418C19.0973 15.418 15.3691 20.5553 15.3691 26.8925C15.3691 33.2297 19.0973 38.367 23.6963 38.367Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3081 35.6388C24.6076 35.6388 26.4717 33.0675 26.4717 29.8956C26.4717 26.7237 24.6076 24.1523 22.3081 24.1523C20.0086 24.1523 18.1445 26.7237 18.1445 29.8956C18.1445 33.0675 20.0086 35.6388 22.3081 35.6388Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4999 53.8849C36.3185 53.8849 37.9097 55.1173 38.9028 57.0078C39.5488 55.7754 39.9437 54.2798 39.9437 52.6405C39.9437 48.5006 37.5149 45.1504 34.5119 45.1504C31.5088 45.1504 29.0801 48.5006 29.0801 52.6405C29.0801 54.2798 29.4749 55.7754 30.121 57.0078C31.102 55.1293 32.7053 53.8849 34.5238 53.8849H34.4999Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5005 60.1305C36.3191 60.1305 37.9103 58.8981 38.9034 57.0076C37.9223 55.1291 36.3191 53.8848 34.5005 53.8848C32.6819 53.8848 31.0907 55.1172 30.0977 57.0076C31.0787 58.8862 32.6819 60.1305 34.5005 60.1305Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFearIcon);
export default __webpack_public_path__ + "static/media/fear-icon.dc1787e0f5801b0bacfa18601e58ad0a.svg";
export { ForwardRef as ReactComponent };